import Campaign from "./pages/Campaign/Campaign";
import Campaign2 from "./pages/Campaign2/Campaign2";
import HomePageV3 from "./pages/HomePageV3/HomePageV3";
import QuizPage from "./pages/QuizPage/QuizPage";
import QuestionBodyMemoryMatch from "./pages/QuizPage/QuestionBodyMemoryMatch/QuestionBodyMemoryMatch";

export const routes = [
  {
    path: "/",
    element: <HomePageV3 />,
  },
  {
    path: "/campaign/",
    element: <Campaign subscriptionType="Wordly" campaignPageNumber="1" bannerImgSrc="/banners/campaign/camp1_updated.jpeg" loginPlacement="bottom"/>,
  },
  {
    path: "/campaign2/",
    element: <Campaign subscriptionType="Wordly" campaignPageNumber="2" bannerImgSrc="https://ms.quizard.live/bkash-quiz-banner/camp-banner/wordly/wordly.jpg" />,
  },
  {
    path: "/campaign3/",
    element: <Campaign subscriptionType="SpellingBee" campaignPageNumber="3" bannerImgSrc="https://ms.quizard.live/bkash-quiz-banner/camp-banner/wordly/spelling.jpg"/>,
  },
  {
    path: "/campaign4/",
    element: <Campaign2 campaignNumber={4} />,
  },
  {
    path: "/campaign5/",
    element: <Campaign subscriptionType="MemoryMatch" campaignPageNumber="5" bannerImgSrc="https://ms.quizard.live/bkash-quiz-banner/camp-banner/wordly/memory.jpg"/>,
  },
  {
    path: "/quiz/",
    element: <QuizPage />,
  },
  {
    path: "/memory-match-game/",
    element: <QuestionBodyMemoryMatch />,
  },
];
